import { render } from "./VideoPlayerPtzPanel.vue?vue&type=template&id=018dd2c4&ts=true"
import script from "./VideoPlayerPtzPanel.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerPtzPanel.vue?vue&type=script&lang=ts"

import "./VideoPlayerPtzPanel.vue?vue&type=style&index=0&id=018dd2c4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__